import ActionNode from './ActionNode'

class ActionNodeCondition extends ActionNode {
  constructor(model) {
    super(model)
    this.text = model.value.text
    this.question = model.value.questions
    this.icon = {
      ...this.icon,
      name: 'question'
    }
  }

  changeValue(value) {
    this.text = value.text
    this.value = value
  }
}

export default ActionNodeCondition



// WEBPACK FOOTER //
// ./src/utils/models/node/ActionNodeCondition.js